import axios from "axios";
import { serverUrl } from "../../serverUrl";

import * as databaseActions from "../actions/databaseActions";

const clearStoredSession = () => {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.removeItem("currentTable");
  window.sessionStorage.clear();
};

const loadUserSession = (dispatch, user) => {
  clearStoredSession();
  dispatch(clearSession());
  dispatch(setUser(user));
  dispatch(databaseActions.getRetail(user.user_id));
  dispatch(databaseActions.getResto(user.user_id));
  dispatch(databaseActions.getRestoK(user.user_id));
  dispatch(databaseActions.getRetailX(user.user_id));
};

export const getUser = ({ username, password, setNotification }) => {
  return (dispatch) => {
    const config = {
      method: "post",
      url: `${serverUrl}/api/login`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { username, password },
    };
    return axios(config)
      .then((resp) => {
        loadUserSession(dispatch, resp.data);
        return resp.data;
      })
      .catch((err) => {
        console.log(err);
        setNotification({ show: true, msg: "Incorrect username or password" });
        throw err;
      });
  };
};

const setUser = (user) => ({ type: "SET_USER", payload: user });
export const clearSession = () => ({ type: "CLEAR_SESSION" });

export const autoLogin = ({ token }) => {
  return (dispatch) => {
    const config = {
      method: "post",
      url: `${serverUrl}/api/auto-login`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { autologinToken: token },
    };

    return axios(config).then((resp) => {
      loadUserSession(dispatch, resp.data);
      return resp.data;
    });
  };
};

export const createUser = ({ username, password, company, setNotification, onCreate }) => {
  return (dispatch) => {
    const config = {
      method: "post",
      url: `${serverUrl}/api/registration`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { username, Password: password, company },
    };
    axios(config)
      .then((resp) => {
        console.log("resp create user", resp);
        //dispatch(setUser(resp.data));
        onCreate();
      })
      .catch((err) => {
        console.log(err);
        setNotification({
          show: true,
          msg: "Unable to register at this moment, please contact support",
        });
      });
  };
};
